/***
 * 快麦通环境和erp环境有个对应关系，在这里了会出现部分链接的映射关系，
 * 封装出一个公用的方法统一维护环境映射关系
 *
 */

/**
 * 快麦通环境与erp环境映射关系
 * 环境变化修改配置就好了
 * @type {{}}
 */

const erpEnvHostMapper = {
  erp1: 'https://erp1.superboss.cc/',
  erp2: 'https://erp2.superboss.cc/',
  erp3: 'https://erp3.superboss.cc/',
  erp4: 'https://erp4.superboss.cc/',
  erp5: 'https://erp5.superboss.cc/',
  erp6: 'https://erp6.superboss.cc/',

  erpa: 'https://erpa.superboss.cc/',
  erpb: 'https://erpb.superboss.cc/',
  viperp: 'https://viperp.superboss.cc/',
  erp: 'https://erp.superboss.cc/',
};
const gylEnvHostMapper = {
  erp2: 'https://puhuo.kuaimaitong.com/erppuhuo/',
  erp3: 'https://puhuo3.kuaimaitong.com/erppuhuo/',

  erp1: 'https://puhuo1.kuaimaitong.com/erppuhuo/',
  erp4: 'https://puhuo4.kuaimaitong.com/erppuhuo/',
  erp5: 'https://puhuo5.kuaimaitong.com/erppuhuo/',
};

const kuaiMaiTongEnvMapper = {
  'scm.superboss.cc': 'erp',
  'scma.superboss.cc': 'erpa',
  'scmb.superboss.cc': 'erpb',
  'vipscm.superboss.cc': 'viperp',
  'scm1.superboss.cc': 'erp1',
  'scm2.superboss.cc': 'erp2',
  'scm2-tmp.superboss.cc': 'erp2',
  'scm3.superboss.cc': 'erp3',
  'scm4.superboss.cc': 'erp4',
  'scm5.superboss.cc': 'erp5',
  'scm6.superboss.cc': 'erp6',
  
  'puhuo.kuaimaitong.com':'erp2',
  'puhuo3.kuaimaitong.com':'erp3',
  'puhuo1.kuaimaitong.com':'erp1',
  'puhuo4.kuaimaitong.com':'erp4',
  'puhuo5.kuaimaitong.com':'erp5',
  
};
const getCurrentEvnName = function () {
  const host = window.location.host;
  if (kuaiMaiTongEnvMapper[host]) {
    return kuaiMaiTongEnvMapper[host];
  } else {
    return 'erp3';
  }
};

/**
 * 获取当前快麦通环境对应的erp环境host
 * @returns {string|*}
 */
const getErpHost = function () {
  const env = getCurrentEvnName();
  
  // 判断是否有对应的erp环境，或者货源池过来对应的环境
  let host = window.location.host; 
  if(host.indexOf('kuaimaitong.com') > -1){
    if (gylEnvHostMapper[env]) {
      // 判断是否有对应的erp环境，或者货源池过来对应的环境
      return gylEnvHostMapper[env];
    } else {
      console.warn('未找到对应erp环境，请检查环境配置');
      return '';
    }
  }else{
    if (erpEnvHostMapper[env]) {
      return erpEnvHostMapper[env];
    } else {
      console.warn('未找到对应erp环境，请检查环境配置');
      return '';
    }
  }
};
// 获取当前快麦通环境对应的erp环境host （日志相关接口）
const getErpLogHost = function () {
  const map = {
    'scm.superboss.cc': 'erp',
    'scma.superboss.cc': 'erp',
    'scmb.superboss.cc': 'erp',
    'vipscm.superboss.cc': 'erp',
    'scm1.superboss.cc': 'erp1',
    'scm2.superboss.cc': 'erp1',
    'scm2-tmp.superboss.cc': 'erp1',
    'scm3.superboss.cc': 'erp3',
    'scm4.superboss.cc': 'erp1',
    'scm5.superboss.cc': 'erp1',
    'scm6.superboss.cc': 'erp1',
  };
  // 判断是否有对应的erp环境，或者货源池过来对应的环境
  let host = window.location.host; 
  const env = map[host] || 'erp3';
  if (erpEnvHostMapper[env]) {
      return erpEnvHostMapper[env];
  } else {
      console.warn('未找到对应erp环境，请检查环境配置');
      return '';
  }
};

/**
 * 打开erp页面
 * @param hash
 */

const openErpPage = function (hash) {
  const erpHost = getErpHost();
  window.open(erpHost + 'simple.html' + hash);
};

// 获取dam 对应快麦通环境地址
const getDamHost = function () {
   // 定义环境与域名映射
   // 测试环境： damtest5.leycloud.com
   // 灰度环境： damgray.leycloud.com
   // 线上环境： dam.leycloud.com
   const ENV_DOMAIN_MAP = {
    'scm3': 'damtest5.leycloud.com',  
    'local-scm': 'damtest5.leycloud.com', 
    'scm1': 'dam.leycloud.com',
    'scm4': 'dam.leycloud.com',
    'scm5': 'dam.leycloud.com',
    'scm': 'dam.leycloud.com',
    };
    
    // 获取当前环境对应的DAM域名，优先匹配更长的键，避免 'scm' 抢占 'local-scm' 等
    const env = Object.keys(ENV_DOMAIN_MAP)
      .sort((a, b) => b.length - a.length)
      .find(env =>  location.host.includes(env))
    return ENV_DOMAIN_MAP[env] ||  'damtest5.leycloud.com';
};

/**
 * 获取星云供应链域名映射
 * @param url
 */
const getXyGylHost = function () {
   // 定义环境与域名映射
   // 测试环境： xygyl-test.kuaimaitong.com
   // 灰度环境： xygyl-pre.kuaimaitong.com
   // 线上环境： xygyl.kuaimaitong.com
   const ENV_Xy_GYL_DOMAIN_MAP = {
    'scm3': 'xygyl-test.kuaimaitong.com',  
    'local-scm': 'xygyl-test.kuaimaitong.com', 
    'scm1': 'xygyl.kuaimaitong.com',
    'scm4': 'xygyl.kuaimaitong.com',
    'scm5': 'xygyl.kuaimaitong.com',
    'scm': 'xygyl.kuaimaitong.com',
    };
    
    // 获取当前环境对应的DAM域名
    const env = Object.keys(ENV_Xy_GYL_DOMAIN_MAP).find(env =>  location.host.includes(env))
    return ENV_Xy_GYL_DOMAIN_MAP[env] ||  'xygyl.kuaimaitong.com';
};

export { getErpHost, openErpPage, getDamHost,getErpLogHost, getXyGylHost };
// 基于当前 SCM 灰度环境获取新素材空间 appKey
const getFilesAppKey = function () {
  const MAP = {
    // 灰度3
    'scm3': 'jY0KjDZV2QGgKvov',
    'local-scm': 'jY0KjDZV2QGgKvov',
    // 其他灰度
    'scm1': 'OgqLKw7jCpaLzapw',
    'scm4': 'OgqLKw7jCpaLzapw',
    'scm5': 'OgqLKw7jCpaLzapw',
    'scm': 'OgqLKw7jCpaLzapw',
  };
  const host = window.location.host || '';
  const matchedEnv = Object.keys(MAP)
    .sort((a, b) => b.length - a.length)
    .find(env => host.includes(env));
  return MAP[matchedEnv] || 'jY0KjDZV2QGgKvov';
};

export { getFilesAppKey };

// 基于当前灰度环境获取新素材空间域名
// 需求：
// 1）灰度3 -> imgeditor-dev.superboss.cc
// 2）本地(包含 local-scm) -> imgeditor-dev.superboss.cc
// 其余灰度 -> imgeditor.superboss.cc
const getImgEditorOrigin = function () {
  const hostname = window.location.hostname || '';
  // 本地开发域名识别
  const isLocal = (
    hostname.includes('local-scm')
  );
  // 灰度3识别
  const isGray3 = hostname === 'scm3.superboss.cc' || hostname.includes('scm3.');
  if (isLocal || isGray3) {
    return 'https://imgeditor-dev.superboss.cc';
  }
  return 'https://imgeditor.superboss.cc';
};

export { getImgEditorOrigin };
